import LinePlaneReturnIcon from 'LuxKit/Icons/line/LinePlaneReturnIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { useIntl } from 'react-intl'

function ReturnFareFreeLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel icon={<LinePlaneReturnIcon />}>
      {intl.formatMessage({
        id: '9Eo2a_5_nIFr21dGLq58',
        defaultMessage: 'Return flight for free',
        description: 'Promotional badge shown when the Maldives charter return economy flight fare is free',
      })}
    </PromotionLabel>
  )
}

export default ReturnFareFreeLabel
